/**
 * Per-bid requirement references ("REQ-12") for compliance items.
 *
 * The backend twin is `backend/src/lib/requirement-refs.ts` — keep the two
 * formats identical. This side carries format + parse only.
 */

const REQ_REF_PATTERN = /^REQ[\s\-–—]?(\d+)$/i

/** "REQ-12" for a minted number; null when the item has none (e.g. awaiting review). */
export function formatReqRef(displayNumber: number | null | undefined): string | null {
  if (displayNumber == null || !Number.isSafeInteger(displayNumber) || displayNumber < 1) return null
  return `REQ-${displayNumber}`
}

/**
 * The number inside a REQ reference. Case-insensitive; accepts "REQ-12",
 * "req 12" and "REQ12". The whole string must be the reference.
 */
export function parseReqRef(text: string): number | null {
  const match = REQ_REF_PATTERN.exec(text.trim())
  if (!match) return null
  const value = Number(match[1])
  return Number.isSafeInteger(value) && value >= 1 ? value : null
}
